import React, { useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { galleryImages } from '../data/mock';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';

const Gallery = () => {
  const { t } = useLanguage();
  const [selectedImage, setSelectedImage] = useState(null);

  const filterImages = (category) => {
    if (category === 'all') return galleryImages;
    return galleryImages.filter(img => img.category === category);
  };

  return (
    <section id="gallery" className="py-20" style={{ backgroundColor: 'var(--cream)' }}>
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="mb-3">{t.gallery.title}</h2>
        </div>

        <Tabs defaultValue="atmosphere" className="w-full">
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-3 mb-8 bg-white shadow-sm">
            {/* <TabsTrigger value="all" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.gallery.all}
            </TabsTrigger> */}
            <TabsTrigger value="all" disabled className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)] pointer-events-none cursor-default">              {t.gallery.all}
            </TabsTrigger>

            {/* <TabsTrigger value="food" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.gallery.food}
            </TabsTrigger> */}
            <TabsTrigger value="atmosphere" className="data-[state=active]:bg-[var(--amber)] data-[state=active]:text-[var(--brown-dark)]">
              {t.gallery.atmosphere}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="all" className="animate-in fade-in duration-500">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {filterImages('all').map((image) => (
                <div
                  key={image.id}
                  className="aspect-square overflow-hidden rounded-lg cursor-pointer group"
                  onClick={() => setSelectedImage(image)}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="food" className="animate-in fade-in duration-500">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {filterImages('food').map((image) => (
                <div
                  key={image.id}
                  className="aspect-square overflow-hidden rounded-lg cursor-pointer group"
                  onClick={() => setSelectedImage(image)}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              ))}
            </div>
          </TabsContent>

          <TabsContent value="atmosphere" className="animate-in fade-in duration-500">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
              {filterImages('atmosphere').map((image) => (
                <div
                  key={image.id}
                  className="aspect-square overflow-hidden rounded-lg cursor-pointer group"
                  onClick={() => setSelectedImage(image)}
                >
                  <img
                    src={image.url}
                    alt={image.alt}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
              ))}
            </div>
          </TabsContent>
        </Tabs>

        {/* Lightbox */}
        {/* {selectedImage && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <div className="max-w-5xl max-h-[90vh]">
              <img
                src={selectedImage.url}
                alt={selectedImage.alt}
                className="w-full h-full object-contain"
              />
            </div>
          </div>
        )} */}
        {selectedImage && (
          <div
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
          <img
            src={selectedImage.url}
            alt={selectedImage.alt}
            className="max-w-[90vw] max-h-[90vh] w-auto h-auto object-contain rounded-lg"
          />
          </div>
        )}

      </div>
    </section>
  );
};

export default Gallery;